<div class="container">

  <div class="notification-filters">
    <div class="dropdown-container" *ngIf="!asChecked">
      <app-dropdown-button class="drop-btn" [label]="'Ordenar'" [(isOpen)]="showOrdenar" (valueChange)="showOrdenar = $event">
        <ul class="dropdown-text-list">
          <li id="readOrder" (click)="getNotifications({order: 'read:DESC'}) ; showOrdenar=false">Lidas</li>
          <li id="notReadOrder" (click)="getNotifications({order: 'read:ASC'}) ; showOrdenar=false">Não Lidas</li>
          <li id="recentDateOrder" (click)="getNotifications({order: 'date:DESC'}) ; showOrdenar=false">Mais recentes</li>
          <li id="latestDateOrder" (click)="getNotifications({order: 'date:ASC'}) ; showOrdenar=false">Mais antigas</li>
        </ul>
      </app-dropdown-button>
    </div>
    
      <div class="dropdown-container" *ngIf="!asChecked">
       <app-dropdown-button class="drop-btn" [alignRight]="true" [floatOnMobile]="true" [label]="'Filtrar'" [(isOpen)]="showFilter" (valueChange)="showFilter = $event">
        <div class="calendar-container">  
          <div class="inputs-container">
            <div class="calendar-input-box">
              <nz-date-picker 
              nzClassName="datepicker" 
              nzDropdownClassName="datepicker-popup"
              nzFormat="dd/MM/yyyy" 
              nzPlaceHolder="De" 
              [nzDisabledDate]="disabledStartDate" 
              [(ngModel)]="dateFilter.from"></nz-date-picker>
            </div>      
            <div class="calendar-input-box" style="margin-left: 10px;">
              <nz-date-picker
              nzClassName="datepicker" 
              nzDropdownClassName="datepicker-popup"
              nzFormat="dd/MM/yyyy" 
              nzPlaceHolder="Até" 
              [nzDisabledDate]="disabledEndDate" 
              [(ngModel)]="dateFilter.to"></nz-date-picker >
            </div>
          </div>          
          <div class="btns-container">
            <lib-button-tertiary id="clearDateBtn" (click)="clearDateFilter(); showFilter = false">Cancelar</lib-button-tertiary>
            <lib-button-primary id="sendDateFilterBtn" (click)="getNotifications(); showFilter = false">Filtrar</lib-button-primary>
          </div>  
        </div>
      </app-dropdown-button> 
    </div>  

    <div class="dropdown-container" *ngIf="asChecked">
      <app-dropdown-button class="drop-btn" [label]="'Ações'" [(isOpen)]="showActions" (valueChange)="showActions = $event">
        <ul class="dropdown-text-list">
          <li id="readAction" (click)="readAction(true)">Marcar como lida</li>
          <li id="notReadAction" (click)="readAction(false)">Marcar como não lida</li>
        </ul>
      </app-dropdown-button>
    </div>
    <lib-input-checkbox class="check-all" [(ngModel)]="checkAll" (change)="checkAllClick()"></lib-input-checkbox>
  </div>

  <div id="notificationScroll" class="message-list">
    <div class="message-card" id="{{'notification-list-item-' + i}}" *ngFor="let item of items;let i = index; let last = last;">
      <app-message-item id="{{last ? 'last-message' : ''}}" [message]="item" (clickCard)="clickMessage(item)" (clickCheckbox)="setAsChecked()"></app-message-item>
    </div>
    <div class="loading-msges" *ngIf="loadingMessages">
      <lib-loading></lib-loading>
    </div>
    <div class="loading-msg" *ngIf="loadingMoreMessages">
      <lib-loading></lib-loading>
    </div>
  </div>
</div>